import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { joinList } from '../../utils/joinList.js';
import { Button } from '../Button/Button.js';
import { SlideCheckboxGroup } from '../SlideCheckboxGroup/SlideCheckboxGroup.js';
import { Text } from '../Text/Text.js';
export const FiltrationForm = JSX(({ children, filtrationSchema, resetButton, field, reset }) => (_jsxs("form", { className: "flex flex-col @4xl:flex-row justify-between bg-white p-4xl gap-s @4xl:gap-0", children: [_jsxs("div", { className: "flex flex-col @4xl:flex-row gap-xl", children: [children, joinList((_jsx("div", { className: "h-full w-px bg-gray hidden @4xl:block" })))(Object.entries(filtrationSchema).map(renderFormItem(field)).filter(Boolean))] }), resetButton ? (_jsx("div", { children: _jsx(Button, { type: "reset", className: "w-full @4xl:w-56 @4xl:ml-s", onClick: reset, children: resetButton?.text }) })) : null] })));
const renderFormItem = (field) => ([key, item]) => {
    const type = item?.type;
    switch (type) {
        case 'array':
            return renderCheckboxes(key, field)(item);
        default:
            return null;
    }
};
const renderCheckboxes = (key, field) => (item) => {
    const options = item?.items?.enum?.map((e, i) => ({ value: e, title: item?.items?.enumNames?.[i] || '' })) ||
        [];
    return (_jsxs("div", { className: "flex-1", children: [item?.title ? (_jsx("div", { className: "mb-m", children: _jsx(Text, { size: "text-m", font: "font-medium", color: "text-primary-text", children: item.title }) })) : null, _jsx(SlideCheckboxGroup, { items: options, multiple: !item?.single, ...field(key) })] }, key));
};
//# sourceMappingURL=FiltrationForm.js.map